// AGC: CulturasSettings - Sub-page of Settings > Sistema > Tipos de Culturas
// AGC: Manages built-in + custom crop type list (shared with SelectCrop picker).

import React, { useMemo } from 'react'
import { Sprout } from 'lucide-react'
import { CustomListSettingsPage } from './CustomListSettingsPage'
import { useTranslation } from '../../hooks/useTranslation'
import { CROP_TYPES } from '../../types/field'
import type { CustomListItem } from '../inventory/ManageCategoriesUnitsModal'
import type { Screen } from '../../types'

// AGC: Shared storage key — must match the one read by SelectCrop and other consumers
export const STORAGE_KEY_CUSTOM_CROP_TYPES = 'droidfarm_custom_crop_types'

interface CulturasSettingsProps {
  onBack: () => void
  onNavigate: (screen: Screen) => void
}

export const CulturasSettings: React.FC<CulturasSettingsProps> = ({ onBack }) => {
  const { t } = useTranslation()

  const builtInItems = useMemo<CustomListItem[]>(
    () => CROP_TYPES.map((c) => ({ id: c.id, label: `${c.icon} ${c.name}` })),
    []
  )

  return (
    <CustomListSettingsPage
      title={t('profile.settingsCropTypes')}
      defaultSectionTitle={t('profile.customListDefault')}
      customSectionTitle={t('profile.customListCustom')}
      emptyText={t('profile.customListEmpty')}
      addPlaceholder={t('profile.settingsCropTypes')}
      builtInItems={builtInItems}
      storageKeyPrefix={STORAGE_KEY_CUSTOM_CROP_TYPES}
      onBack={onBack}
      Icon={Sprout}
    />
  )
}
